export class AssignmentStatus {
  id: number;
  description: string;

  constructor(obj) {
    this.id =               obj && obj.id;
    this.description =      obj && obj.description          || null;
  }
}
